import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick,
  variant = 'primary'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const variants: Record<string, string> = {
    primary: 'bg-brand-lime hover:bg-[#7da300] text-white shadow-lg',
    secondary: 'bg-brand-orange hover:bg-[#e67a2e] text-white shadow-lg'
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full
    px-6 py-4
    font-heading font-bold text-base uppercase tracking-wide
    rounded-lg
    transition-colors duration-200
    ${variants[variant]}
    ${className}
  `;
  const content = <span className="flex items-center text-center justify-center gap-2" data-id="element-40">
      {children}
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-41">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-42">
      {content}
    </button>;
}